// extracted by mini-css-extract-plugin
export default {"container":"InfoCardColumnsWrapper_container__xCH+9"};